import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import useLoader from '../../../../hooks/useLoader'
import useForm from '../../../../hooks/useForm'
import Form from '../../../../components/forms/Form'
import { brandFields } from '../../../../constants/forms/almoxarifado/brandFields'
import {
  cleanPayload,
  normalizeFormErrors,
  setDefaultFieldValues,
} from '../../../../utils/objectUtils'
import useBaseService from '../../../../hooks/services/useBaseService'
import { entities } from '../../../../constants/entities'
import PageHeader from '../../../../components/PageHeader'
import SimpleBody from '../../../../components/forms/SimpleBody'
import SectionHeader from '../../../../components/forms/SectionHeader'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import MainLayout from '../../../../layouts/MainLayout'

const CreateBrandsPage = () => {
  const navigate = useNavigate()
  const {
    post: baseServicePost,
    formErrors,
    setFormErrors,
  } = useBaseService(navigate)
  const { showLoader, hideLoader } = useLoader()
  const queryClient = useQueryClient()

  const [brandSection] = brandFields

  const { formData, handleChange, resetForm } = useForm(
    setDefaultFieldValues([brandSection]),
    [brandSection]
  )

  const createBrand = useMutation({
    mutationFn: async (data) => {
      showLoader()
      const response = await baseServicePost(entities.brands.create, data)
      return response
    },
    onSuccess: (response) => {
      if (response?.status === 201) {
        hideLoader()
        resetForm()
        navigate('/almoxarifado/produtos/marcas')
        queryClient.invalidateQueries({
          queryKey: ['almox_brands'],
        })
        queryClient.invalidateQueries({
          queryKey: ['brandOptions'],
        })
      }
    },
    onError: (error) => {
      console.log('onError ', error)
      if (error.response?.data?.errors) {
        setFormErrors(error.response.data.errors)
      }
      hideLoader()
    },
    onSettled: () => {
      hideLoader()
    },
  })
  const handleSubmit = async () => {
    try {
      const cleanedData = cleanPayload(formData)
      const payload = {
        brand: {
          ...cleanedData.brand,
        },
      }
      return await createBrand.mutateAsync(payload)
    } catch (error) {
      console.error('Erro ao enviar marca:', {
        status: error.status,
        message: error.message,
      })
    }
  }

  const handleBack = () => {
    navigate(`/almoxarifado/produtos/marcas`)
  }

  // Consolidação dos estados de carregamento para o loader global
  const isPageLoading = createBrand.isPending

  useEffect(() => {
    if (isPageLoading) {
      showLoader()
    } else {
      hideLoader()
    }
  }, [isPageLoading, showLoader, hideLoader])

  return (
    <MainLayout>
      <PageHeader
        title="Criar Marca"
        showBackButton={true}
        backUrl="/almoxarifado/produtos/marcas"
      />
      <div className="container-fluid p-1">
        <Form
          initialFormData={formData}
          onSubmit={handleSubmit}
          textSubmit="Criar Marca"
          textLoadingSubmit="Criando..."
          handleBack={handleBack}
          isLoading={isPageLoading || createBrand.isPending}>
          {() => {
            const renderedSections = new Set()

            return brandFields.map((section, index) => {
              const sectionType = section.section.split(' - ')[0]
              const showHeader = !renderedSections.has(sectionType)

              if (showHeader) {
                renderedSections.add(sectionType)
              }

              return (
                <div key={section.section + ' ' + index}>
                  {showHeader && (
                    <SectionHeader
                      section={section.section}
                      viewTable={false}
                      setViewTable={() => {}}
                      addFieldsInData={() => {}}
                    />
                  )}

                  <SimpleBody
                    fields={section.fields}
                    formErrors={normalizeFormErrors(formErrors)}
                    formData={formData}
                    handleFieldChange={handleChange}
                    getOptions={() => {}}
                    getSelectedValue={() => {}}
                  />
                </div>
              )
            })
          }}
        </Form>
      </div>
    </MainLayout>
  )
}

export default CreateBrandsPage
